
import { defineComponent, ref, Ref, onMounted, inject } from "vue";
import CloseSVG from "@/components/CloseSVG.vue";
import useSaveAndContinue from "@/composables/useSaveAndContinue";

export default defineComponent({
  name: "NameAndContinue",
  components: {
    CloseSVG,
  },
  setup() {
    const closeModal = inject("closeModal") as () => void;
    const bounceTransition = inject("bounceTransition") as Ref<string>;
    const fadeTransition = inject("fadeTransition") as Ref<string>;

    const loading = ref<boolean>(false);
    const artworkName = ref<string>("Design 1");

    const saveAndContinue = async () => {
      loading.value = true;
      loading.value = await useSaveAndContinue({title: artworkName.value});
    }

    const title = ref("");
    onMounted(() => {
      //Trigger rerender on mount
      title.value = "Please save your design to continue";
    });

    return {
      closeModal,
      fadeTransition,
      bounceTransition,
      loading,
      title,
      artworkName,
      saveAndContinue,
    };
  },
});
